<template>
  <div class="deletion-title">
    <h1>Cancellazione Dati e Account</h1>
    <p class="subtitle">
      Informazioni e strumenti per eliminare i tuoi dati personali in conformità
      con il GDPR, Google Play Store e Apple App Store
    </p>
  </div>
</template>

<script>
export default {
  name: 'DataDeletionTitle'
}
</script>

<style scoped>
.deletion-title {
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.deletion-title h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
  font-weight: 300;
}

@media (max-width: 768px) {
  .deletion-title h1 {
    font-size: 2.2rem;
  }

  .subtitle {
    font-size: 1.1rem;
  }
}
</style>
